import { Modal, ModalProps } from "antd";

interface DFPModalProps extends ModalProps {}

export const DFPModal = ({ ...props }: DFPModalProps) => {
	return <Modal {...props} />;
};
